import { createSlice } from "@reduxjs/toolkit";

interface DarkModeState {
  isDarkMode: boolean;
}

const initialState: DarkModeState = {
  isDarkMode: JSON.parse(localStorage.getItem("isDarkMode") || "true"),
};

const darkModeSlice = createSlice({
  name: "darkMode",
  initialState,
  reducers: {
    // Action um den Darkmode umzuschalten
    toggleDarkMode: (state) => {
      state.isDarkMode = !state.isDarkMode;
      localStorage.setItem("isDarkMode", JSON.stringify(state.isDarkMode)); // Speichern in localStorage
    },
  },
});

export const { toggleDarkMode } = darkModeSlice.actions;

export default darkModeSlice.reducer;
